module.exports = __webpack_public_path__ + "static/media/solo67.15207635.JPG";